<rask-page
  pageTitle="{{ 'LEVERANTORSORDER_LIST_ORDERSOK' | translate }}"
  [actionShow]="canEdit()"
  [actionFn]="create"
  actionTitle="{{'LEVERANTORSORDER_LIST_SKAPANYLEV' | translate}}"
  noPadding>
  <ng-container headerContent>
    <form [formGroup]="form" (ngSubmit)="search()">
      <div class="row pb-0">
        <rask-input aid="inputSok" [label]="" class="col-3" formControlName="sok"></rask-input>
      </div>
      <div class="row pb-0">
        <rask-toggle-panel aid="visaFilter" class="col" label="{{ 'DEFAULT_VISA_AVANCERATFILTER' | translate }}"
          [defaultExpanded]="false">
          <rask-search
            aid="inputLeverantor"
            class="col-2"
            label="{{'LEVERANTORSORDER_LIST_HVKODLEV' | translate}}"
            bindLabel="namn"
            bindValue="id"
            formControlName="leverantor"
            typeToSearchText="{{'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate}}"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="searchLeverantorTypeAhead"
            [valueLookup]="searchLeverantorTypeAheadValue"
            [selected]="form.value.leverantor">
          </rask-search>
          <rask-datepicker aid="inputPeriodFrom" class="col-1" formControlName="periodFrom"
            label="{{ 'DEFAULT_PERIODFROM' | translate }}" [minDate]="" [onlyMonths]="false">
          </rask-datepicker>
          <rask-datepicker aid="inputPeriodTom" class="col-1" formControlName="periodTom"
            label="{{ 'DEFAULT_PERIODTOM' | translate }}" [minDate]="" [onlyMonths]="false">
          </rask-datepicker>
          <rask-search
            aid="inputOrdernummer"
            class="col-2"
            label="{{'LEVERANTORSORDER_LIST_ORDERNUMMER' | translate}}"
            bindLabel="namn"
            bindValue="id"
            formControlName="ordernummer"
            typeToSearchText="{{'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate}}"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="searchOrdernummerTypeAhead"
            [valueLookup]="searchOrdernummerTypeAheadValue"
            [selected]="form.value.ordernummer">
          </rask-search>

          <rask-search
            aid="inputAvtalsansvarig"
            class="col-2"
            label="{{'LEVERANTORSORDER_LIST_AVTALSANSVARIG' | translate}}"
            bindLabel="namn"
            bindValue="id"
            formControlName="avtalsansvarig"
            typeToSearchText="{{'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate}}"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="searchAvtalsansvarigTypeahead"
            [valueLookup]="searchAvtalsansvarigTypeaheadValue"
            [selected]="form.value.avtalsansvarig">
          </rask-search>

          @if (baseData) {
            <rask-selector
              aid="inputHandelssortimentsgrupp"
              class="col-2"
              label="{{ 'LEVERANTORSORDER_LIST_HANDELSSORTIMENTSGRUPP' | translate }}"
              formControlName="handelssortimentsgrupp"
              [viewFormatter]="outputformatter"
              [formatter]="formatter"
              [values]="baseData.handelssortimentsgruppList">
            </rask-selector>
          }

          <rask-search
            aid="inputMottagningsplats"
            class="col-2"
            label="{{'LEVERANTORSORDER_LIST_MOTTAGNINNGSPLATS' | translate}}"
            bindLabel="namn"
            bindValue="id"
            formControlName="mottagningsplats"
            typeToSearchText="{{'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate}}"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="searchMottagningsplatsTypeAhead"
            [valueLookup]="searchMottagningsplatsTypeAheadValue"
            [selected]="form.value.mottagningsplats">
          </rask-search>
        </rask-toggle-panel>
      </div>
      <div class="d-flex">
        <rask-submit-button aid="buttonSok" class="ps-0" color="secondary">
        {{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}</rask-submit-button>
        <rask-button aid="buttonRensa" color="secondary" negative (click)="reset()">
        {{ 'DEFAULT_BUTTON_LABEL_RENSA' | translate }}</rask-button>
      </div>
    </form>
  </ng-container>
  <rask-leverantorsorder-list [leverantorsordrar]="leverantorsordrar"></rask-leverantorsorder-list>
</rask-page>
